rdefine('app/formular/components/frm/Photo',['backbone','app/formular/components/BaseEditForm','text!formular/frm.photo.html'],function(Backbone,BaseEditForm,tPlaceholder) {
    var iduppload = 0;
    return BaseEditForm.extend({
        bindings:{
        },
        init:function() {
            this.$sel=this.$el.find(".card-body");
            this.$sel.html(Template7.compile(tPlaceholder)({idupload:iduppload++}));
        }
    });
});